import { makeStyles } from "@material-ui/core";

const SIDEBAR_WIDTH = 240;
const PADDING_TOP = 10;
const PADDING_LEFT = 10;

export default makeStyles({
    root: {
        display: "flex",
        minHeight: "100%",
    },
    main: {
        position: "absolute",
        paddingTop: PADDING_TOP + 30,
        paddingLeft: '30%',
        paddingRight: '30%',
        paddingBottom: 300,
        flexGrow: 1,
        minWidth: "100%",
        textAlign: "left",
    },
    sidebar: {
        position: "fixed",
        paddingTop: PADDING_TOP,
        paddingLeft: PADDING_LEFT,
        width: SIDEBAR_WIDTH,
    }
});
